module.exports = __webpack_public_path__ + "static/media/UnitedSansReg-Light.e80c635e.woff2";